import React from 'react';
import styled from 'styled-components';
import GeneraTabla from '../components/Tablas';
import Barras from '../components/Barras';
import { addDot } from '../utils/index';
import { useTranslate } from '../contexts/languageContext';
import { useIsDesktop, useIsMobile } from '../hooks/useMediaQuery';
import constantes from '../resources/constantes.json'
import { themes } from '../styles/themes';

const TablaPartidos = ({ data, nomenclator }) => {
  const t = useTranslate();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  if (!data) return <div>No hay infomación</div>;
  if (!data[0])
    return <SinInfo>{t('sinInformacion')}</SinInfo>;
  return (
    <TablaSpread
      isDesktop={isDesktop}
      caption={<span className="visually-hidden">Tabla del ranking</span>}
      columns={{
        assets: {
          align: ['start'],
          padding: [!isMobile ? 1 : 0.8],
        },
        render: data => [
          <FilaPartido
            isMobile={isMobile}
            nomPar={nomenclator.partidos[Number(data.codpar) - 1].nombre}
            votAct={data.vot.act}
            votAnt={data.vot.ant}
            votAntAnt={data.vot.antant}
            pvotAct={data.pvot.act}
            pvotAnt={data.pvot.ant}
            pvotAntAnt={data.pvot.antant}
          />,
        ],
      }}
      data={data}
      hoverColor={'#eaeaea'}
      oddStripesColor={'#D8DFEA66'}
      tbodyRowHeight={'5em'}
      cellTabindex={true}
    />
  );
};

export default TablaPartidos;

const TablaSpread = styled(GeneraTabla)`
  width: ${({ isDesktop }) => (isDesktop ? '98%' : '100%')};
  border-spacing: 0;
  text-transform: uppercase;
  & caption {
    text-align: left;
    line-height: 2em;
  }
`;

const FilaPartido = ({
  isMobile,
  nomPar,
  votAct,
  votAnt,
  votAntAnt,
  pvotAct,
  pvotAnt,
  pvotAntAnt,
}) => {

  return (
    <Celda isMobile={isMobile}>
      <div>{nomPar}</div>
      <WrapDatos isMobile={isMobile}>
        <FilaDato isMobile={isMobile}>
          <DataWrapper>
            <DataYear>
              {constantes.años.añoAct}
            </DataYear>
            <DataValues>{addDot(votAct)} ({pvotAct})
            </DataValues>
          </DataWrapper>
          <Barras
            width={pvotAct.replace(/,/g, '.')}
            fill={themes.actColor}
            height={'16px'}
            round={true}
            border={true}
          />
        </FilaDato>
        <FilaDato isMobile={isMobile}>
          <DataWrapper>
            <DataYear>
              {constantes.años.añoAnt}
            </DataYear>
            <DataValues>{addDot(votAnt)} ({pvotAnt})
            </DataValues>
          </DataWrapper>
          <Barras
            width={pvotAnt.replace(/,/g, '.')}
            fill={themes.antColor}
            height={'12px'}
            round={true}
            border={true}
          />
        </FilaDato>
        <FilaDato isMobile={isMobile}>
          <DataWrapper>
            <DataYear>
              {constantes.años.añoAntAnt}
            </DataYear>
            <DataValues>{addDot(votAntAnt)} ({pvotAntAnt})
            </DataValues>
          </DataWrapper>
          <Barras
            width={pvotAntAnt.replace(/,/g, '.')}
            fill={themes.antAntColor}
            height={'12px'}
            round={true}
            border={true}
          />
        </FilaDato>
      </WrapDatos>
    </Celda>
  );
};

const Celda = styled.div`

  padding:1.8rem;

  & > div:first-child {
    font-weight: 800;
    font-size: ${({ isMobile }) => (!isMobile ? '1.6rem' : '1.6rem')};
  }
`;

const WrapDatos = styled.div`
  display:flex;
  flex-direction: column;
  gap:1rem;
  font-size: 1.6rem;
  padding-top: 0.4em;
  & > div:first-child {
    font-weight: 900;
    font-size: ${({ isMobile }) => (!isMobile ? '1.6rem' : '1.4rem')};
  }
`;

const FilaDato = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DataWrapper = styled.div`
  display: flex;
  width:100%;
  justify-content: space-between;
  align-items: center;
`;

const DataYear = styled.div``;

const DataValues = styled.div``;


const SinInfo = styled.h4`
  margin-top: 2rem;
  font-size: 1.5rem;
`;
